var map = {
	"./cloud.svg": "+zXD",
	"./controllable.svg": "SHkk",
	"./cost.svg": "HxAL",
	"./customizable.svg": "lBIZ",
	"./eye.svg": "8P1H",
	"./flow.svg": "4A9H",
	"./i18n.svg": "+b9K",
	"./lock.svg": "dOJD",
	"./maintanable.svg": "gqtN",
	"./ok.svg": "R8vL",
	"./scalable.svg": "bzHl",
	"./time.svg": "JUoG",
	"./user.svg": "KvOi"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "iPE+";